module.exports = __webpack_public_path__ + "static/img/qianyiyichang1@2x.96484696.png";